import React from 'react';
import logo from '../assets/logo.png';
import hidevLogo from '../assets/hidev_logo.png';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="container footer-container">
        <div className="footer-logo-container">
          <a href="/">
            <img src={logo} alt="Tri-Bay Electric Logo" className="footer-logo" />
          </a>
        </div>

        <div className="footer-links">
          <nav className="footer-nav">
            <ul className="footer-nav-list">
              <li className="footer-nav-item">
                <a href="#about" className="footer-nav-link">About Us</a>
              </li>
              <li className="footer-nav-item">
                <a href="#who-we-serve" className="footer-nav-link">Who We Serve</a>
              </li>
              <li className="footer-nav-item">
                <a href="#services" className="footer-nav-link">Services</a>
              </li>
              <li className="footer-nav-item">
                <a href="#estimation" className="footer-nav-link">Estimation</a>
              </li>
              <li className="footer-nav-item">
                <a href="#contact" className="footer-nav-link">Contact</a>
              </li>
            </ul>
          </nav>
        </div>

        <div className="hidev-logo-container">
          <a href="https://hidevmobile.com" target="_blank" rel="noopener noreferrer" className="hidev-link">
            <img src={hidevLogo} alt="HiDev Logo" className="hidev-logo" />
          </a>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <p className="copyright">© 2025 Tri-Bay Electric Inc. All Rights Reserved</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 